<template>
<div class="modules">
    <div class="payment-container">
        <div class="summary">
            <h1 class="title"> {{ $t("lang.crypto") }} : {{selectedNetPc.fullName}}</h1>
            <!-- <div class="tools">
                <el-button size="small">Deposit Flat <i class="el-icon-right"></i></el-button>
            </div> -->
        </div>
        <div class="box-wrapper">
            <div class="box-main">
                <div class="step-container">
                    <!-- <div class="step-item">
                        <div class="item-dot">1</div>
                        <div class="item-inner">
                            <div class="item-title">{{ $t("lang.coin") }}</div>
                            <div class="item-form-container">
                                <el-select class="form-select" v-model="form.coin" @change="coinChange"  :placeholder="$t('lang.pleaseCoin')">
                                    <el-option v-for="(item, index) in coinsDataSource" :key="'coin_item_'+index" :value="item.id" :label="item.fullName">
                                        <div class="select-option-coin-item" :class="{'active':!item.enabled}">
                                            <div class="item-icon">
                                                <img :src="domain+item.icon" class="img" />
                                            </div>
                                            <div class="item-title">{{ item.fullName }}</div>
                                            <div class="item-desc">{{ item.shortName }}</div>
                                        </div>
                                    </el-option>
                                </el-select>
                                <div class="common-use" v-if="false">
                                    <div class="item">
                                        <span class="item-icon">
                                            <img :src="require('@/assets/img/coins/USDT.svg')" class="img" />
                                        </span>
                                        <span class="item-text">USDT</span>
                                    </div>
                                    <div class="item">
                                        <span class="item-icon">
                                            <img :src="require('@/assets/img/coins/BTC.svg')" class="img" />
                                        </span>
                                        <span class="item-text">BTC</span>
                                    </div>
                                    <div class="item">
                                        <span class="item-icon">
                                            <img :src="require('@/assets/img/coins/XRP.svg')" class="img" />
                                        </span>
                                        <span class="item-text">XRP</span>
                                    </div>
                                    <div class="item">
                                        <span class="item-icon">
                                            <img :src="require('@/assets/img/coins/TRX.svg')" class="img" />
                                        </span>
                                        <span class="item-text">TRX</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="step-item">
                        <div class="item-dot">2</div>
                        <div class="item-inner">
                            <div class="item-title">{{ $t("lang.network") }}</div>
                            <div class="item-form-container">
                                <el-select class="form-select"
                                 popper-class="form-select-network-dropdown"
                                 v-model="form.network"
                                 @change="networkChange"
                                 :placeholder="$t('lang.pleaseNetwork')">
                                    <el-option-group :label="$t('lang.textRevolution')">
                                        <el-option v-for="(item, index) in networkDataSource" :key="'network_item_'+index" :value="item.id" :label="item.networkName">
                                            <div class="select-option-network-item">
                                                <div class="item-title">{{ item.networkName }}</div>
                                                <div class="item-desc">
                                                    <div class="item-text">{{ item.networkUrl }}</div>
                                                    <div class="item-confirmation">1 Confirmation/s</div>
                                                </div>
                                            </div>
                                        </el-option>
                                    </el-option-group>
                                </el-select>
                            </div>
                        </div>
                    </div> -->
                    <div class="step-item">
                        <!-- <div class="item-dot">3</div> -->
                        <div class="item-inner">
                            <div class="item-title">{{ $t("lang.address") }}</div>
                            <div class="item-form-container">
                                <div class="qrcode-box">
                                    <div class="qrcode">
                                        <vue-qr v-if="address!='' && address!=null && address!=undefined" :text="address"></vue-qr>
                                    </div>
                                    <div class="qrcode-info">
                                        <div class="info-title">{{ $t("lang.address") }}</div>
                                        <div class="info-val">{{ address.address }}</div>
                                    </div>
                                    <div class="qrcode-action">
                                        <div class="icon-copy" @click="copyOrderId(address.address)">
                                            <i class="el-icon-document-copy"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="tips-mod">
                                    <div class="hd">
                                        <div class="tips-title">
                                            {{ $t("lang.minimum") }}
                                        </div>
                                        <div class="tips-con">
                                           {{address.minRechargeCoin  }}
                                        </div>
                                    </div>
                                    <!-- <div class="bd">
                                        <ul class="list">
                                            <li>
                                                Selected wallet: Spot Wallet
                                            </li>
                                            <li>Deposits will be credited and available for Spot Trading after 1 confirmations.</li>
                                            <li>Deposits will be unlocked and available for withdrawal/other activities after 1 network confirmations.</li>
                                            <li>Do not send NFTs to this address. Learn how to deposit NFTs</li>
                                            <li>Deposits via smart contracts are not supported width the exception of ETH via ERC20. Arbitrum & Optimim network or BNB via B$C network.</li>
                                        </ul>
                                    </div> -->
                                    <div class="bt">
                                        <div class="btText">
                                            <el-button type="primary" size="medium "  @click="account" > <span>{{ $t("lang.recharged") }}</span>  </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="box-side">
                <div class="mod">
                    <div class="hd">
                        <h3 class="title">FAQ</h3>
                    </div>
                    <div class="bd">
                        <ul class="list">
                            <li>
                                <div class="item item-video">
                                    <div class="item-icon"></div>
                                    <div class="item-text">How to deposit crypto?(Video)</div>
                                </div>
                            </li>
                            <li>
                                <div class="item">
                                    <div class="item-icon"></div>
                                    <div class="item-text">How to Deposit Crypto Step-by-step Guide</div>
                                </div>
                            </li>
                            <li>
                                <div class="item">
                                    <div class="item-icon"></div>
                                    <div class="item-text">Deposit hasn't arrived?</div>
                                </div>
                            </li>
                            <li>
                                <div class="item">
                                    <div class="item-icon"></div>
                                    <div class="item-text">Deposit & Widthdrawal Status query</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="mod">
                    <div class="hd">
                        <h3 class="title">Other ways to fund</h3>
                    </div>
                    <div class="bd"></div>
                </div>
            </div> -->
        </div>
        <div class="card">
                <div class="hd">
                    <h2 class="title">{{ $t("lang.deposit") }} </h2>
                </div>
                <div class="bd">
                    <div class="table-wrapper">
                        <!-- <div class="table-tools">
                            <div class="table-tabs">
                                <div class="tab-item active">数字币地址转账</div>
                                <div class="tab-item">Revolution用户</div>
                            </div>
                        </div> -->
                        <div   class="table-inner"    element-loading-spinner="el-icon-loading"  >
                            <el-table :data="dataSource">

                                <el-table-column  :label="$t('lang.address')" prop="thirdFlowNo" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.thirdFlowNo }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('lang.amount')" prop="revoCoin" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.revoCoin }}</span>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column :label="$t('lang.Time')" prop="createTime" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.createTime }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('lang.ReviewStatus')" prop="auditStateVal" align="center">
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" :content="scope.row.auditReason" placement="top-start">
                                            <span >{{ scope.row.auditStateVal }}</span>
                                        </el-tooltip>
                                    </template>
                                </el-table-column> -->
                                <!-- <el-table-column :label="$t('lang.ReasonReview')" prop="auditReason" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.auditReason }}</span>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                            <div class="pagination">
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="ipagination.pageNo"
                                    :page-size="ipagination.pageSize"
                                    layout="prev, pager, next, jumper"
                                    :total="ipagination.total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        <!-- <div class="card">
            <div class="hd">
                <h2 class="title">Recent Deposits</h2>
            </div>
            <div class="bd">

            </div>
        </div> -->
    </div>
    <rechargeWarningDial ref="rechargeWarningDial"></rechargeWarningDial>
</div>
</template>
<script>
import {BASE_GLOB_API, BASE_GLOB_DOMAIN} from "@/config.js";
import {axiosGet, axiosPost} from '@/api/api';
import VueQr from 'vue-qr';
import rechargeWarningDial from "@/components/rechargeWarningDial.vue";
import { Toast } from 'vant';

export default {
    name:'payment',
    components:{VueQr, rechargeWarningDial},
    data(){
        return {
            form:{},
            domain:BASE_GLOB_API,
            url:{
                coins:BASE_GLOB_API+'/kanban/coin/platform',
                getPayAddr:BASE_GLOB_API+'/recharge/payee',//获取打款地址
                confirm:BASE_GLOB_API+'/recharge/confirm',
                page:BASE_GLOB_API+'/recharge/page',
            },
            coinsDataSource:[],
            networkDataSource:[],
            address:'',
            lang: "",
            coinsList:[],
            selectedNetPc:{},
            dataSource:[],
            ipagination:{
                pageNo:1,
                pageSize:10,
                total:0
            },
        }
    },
    created(){
        this.lang = sessionStorage.getItem("Language")
        this.selectedNetPc = JSON.parse( sessionStorage.getItem("selectedNetPc"));
        console.log("this.selectedNetPc",this.selectedNetPc)
        if(this.selectedNetPc){
            this.chengNetPc()
            this.selection(1,10)
        }
    },
    mounted() {
        this.$refs.rechargeWarningDial.openDialog(
            this.selectedNetPc.fullName, this.$t('lang.rechargeWarning')
        );
    },
  methods:{
        handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);

                this.selection(val, this.ipagination.pageSize);
            },
        selection(pageNo, pageSize){

          let params = {
            query:{
                btPlatformId:this.selectedNetPc.btPlatformId,
            }
            //   walletId:this.selectedNetPc.id
          };
          axiosPost(this.url.page, params).then(res=>{
              if(res.success){
                let data = res.result;
                this.dataSource = data.records;
                this.ipagination.pageNo = Number(data.current);
                this.ipagination.pageSize =Number(data.size);
                this.ipagination.total =Number(data.total);
              }else{
                  this.$message.error(res.message);
              }
          })
      },
        chengNetPc(e){

            let params = {
                btPlatformId:this.selectedNetPc.btPlatformId,
                btPlatformNetworkId:this.selectedNetPc.btPlatformNetworkId
            };
            axiosGet(this.url.getPayAddr, params).then(res=>{
                console.log("getPayaddr:",res)
                if(res.success){
                    this.address = res.result;
                }else{
                    this.$message.error(res.message);
                }
            })
        },
        account(){
            let params = {
                btPlatformId:this.selectedNetPc.btPlatformId,
                btPlatformNetworkId:this.selectedNetPc.btPlatformNetworkId,
            };
            axiosGet(this.url.confirm, params).then(res=>{
               if(res.code ==200){
                if(res.result){
                    this.$message.success(this.$t("lang.received"));
                    this.$router.push({name:'dashboard'});
                }else{
                    this.$message.error(this.$t("lang.notRreceived"));
                }

               }
            }).catch(err=>{
                console.log("coins catch:",err)
            })
        },
       copyOrderId(content){
            this.$copyText(content).then(res=>{
                Toast.success(this.$t("lang.replicationSuccessful"))
            },
            err => {
                Toast.fail(this.$t("lang.replicationFailed"))
            })
        },
        initCoins(){
            let params = {};
            axiosGet(this.url.coins, params).then(res=>{
                if(res.success){
                    let data = res.result;
                    if(data.length > 0){
                        data.forEach(item=>{
                            if(item.enabled){
                            let source ={
                                enabled:item.enabled,
                                fullName:item.fullName,
                                icon:item.icon,
                                id:item.id,
                                networkVos:item.networkVos,
                                shortName:item.shortName,
                                unit:item.unit,
                            }
                            this.coinsList.push(source)
                            }
                        });
                    }
                    this.coinsDataSource = this.coinsList||[];
                }else{
                    this.$message.error(res.message);
                }
            })
        },
        coinChange(e){
            console.log("e:",e)
            let arr = [];
            this.coinsDataSource.forEach(item=>{
                if(e == item.id){
                    arr = item.networkVos;
                }
            })
            if(arr.length > 0){
                arr.forEach(item=>{
                    if(item.enabled){
                        let source ={
                            btPlatformId:item.btPlatformId,
                            createTime:item.createTime,
                            deleted:item.deleted,
                            deletedVersion:item.deletedVersion,
                            id:item.id,
                            networkName:item.networkName,
                            networkUrl:item.networkUrl,
                            updateTime:item.updateTime,
                        }
                        this.networkDataSource.push(source)
                    }
                });
            }
            // this.networkDataSource = arr;
        },
        networkChange(e){
            let currentObject = {};
            this.networkDataSource.forEach(item=>{
                if(item.id == e){
                    currentObject = item;
                }
            })
            let params = {
                btPlatformId:currentObject.btPlatformId,
                btPlatformNetworkId:currentObject.id
            };
            axiosGet(this.url.getPayAddr, params).then(res=>{
                console.log("getPayaddr:",res)
                if(res.success){
                    this.address = res.result;
                }else{
                    this.$message.error(res.message);
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.payment-container {
    .summary {
        background:#f4f5f6; border-radius:4px; padding:30px; display:flex; justify-content: space-between; align-items: center; margin-bottom:30px;
    }
    .box-wrapper {
        display:flex; justify-content: space-between; align-items: flex-start;
        .box-main {
            flex:1;
            .step-container {
                padding:0 0 0 30px;
                .step-item {
                    position:relative; border-left:#e6e6e6 2px solid;
                    .item-dot {
                        width:28px; height:28px; border-radius:50%; display:flex; justify-content: center; align-items: center; font-size:16px; font-weight:700; background:#f4f5f6; color:#999; position:absolute; left:-15px; top:0;
                    }
                    .item-inner {
                        padding:0 0 30px 30px;
                        .item-title {
                            font-weight:700; font-size:16px; color:#999; padding:3px 0 10px;
                        }
                        .item-form-container {
                            width:80%;
                            .form-select {
                                width:100%;
                            }
                            .common-use {
                                display:flex; justify-content: flex-start; align-items: flex-start; flex-wrap:wrap; padding:10px 0 0;
                                .item {
                                    display:flex; justify-content: center; align-items: center; line-height:1; padding:8px 14px; border-radius:4px; background:#f4f5f6; margin:0 10px 10px 0; cursor: pointer;
                                    .item-icon {
                                        margin-right:4px;
                                        .img {
                                            width:14px; height:14px;
                                        }
                                    }
                                    .item-text {

                                    }
                                    &:hover {
                                        background:#e7eafe; color:#4458fe;
                                    }
                                }
                            }
                            .qrcode-box {
                                background:#f4f5f6; border-radius:4px; padding:15px; display:flex; justify-content: space-between; align-items: center;
                                .qrcode {
                                    width:120px; height:120px; min-width:120px;
                                }
                                .qrcode-info {
                                    padding:0 10px; flex:1;
                                    .info-title {
                                        color:#999;
                                    }
                                    .info-val {
                                        font-weight:700; word-break: break-all; word-wrap: break-word;
                                    }
                                }
                                .qrcode-action {
                                    display:flex; justify-content: center; align-items: center;
                                    .icon-copy {
                                        background:#e6e6e6; border-radius:2px; color:#999; cursor: pointer; width:28px; height:28px; display:flex; justify-content: center; align-items: center;
                                        &:hover {
                                            background:#e7eafe; color:#4458fe;
                                        }
                                    }
                                }
                            }
                            .tips-mod {
                                .hd {
                                    display:flex; justify-content: space-between; align-items: center; font-weight:700; padding:20px 0; border-bottom:#e6e6e6 1px solid;
                                    .tips-title {
                                        color:#666;
                                    }
                                    .tips-con {
                                        color:#333;
                                    }
                                }
                                .bd {
                                    .list {
                                        margin:0 0 0 20px; padding:15px 0 0; color:#999;
                                        &>li {
                                            list-style-type:disc; padding:3px 0;
                                        }
                                    }
                                }
                                .bt{
                                     display: flex;
                                     justify-content: end;
                                    .btText{
                                      padding: 40px 0;
                                    }
                                }
                            }
                        }
                    }
                    &:last-child {border-left-color:transparent;}
                }
            }
        }
        .box-side {
            width:300px; min-width:300px; margin-left:50px;
            .mod {
                .hd {}
                .bd {
                    .list {
                        .item {
                            display:flex; justify-content: flex-start; align-items: flex-start;
                            .item-icon {
                                background:url(~@/assets/img/icon_text.svg) no-repeat center center/contain; width:12px; height:12px; margin:4px 6px 0 0;
                            }
                            .item-text {
                                font-size:14px; color:#666; cursor: pointer;
                                &:hover {
                                    color:#4458fe; text-decoration: underline; opacity: .8;
                                }
                            }
                            &.item-video {
                                .item-icon {
                                    background-image:url(~@/assets/img/icon_video.svg);
                                }
                            }
                        }
                    }
                }
            }
        }
        .mod {
            margin-bottom:20px;
            .hd {
                .title {
                    font-weight:700; font-size:16px;
                }
            }
            .bd {
                .list {
                    &>li {
                        padding:4px 0;
                    }
                }
            }
        }
    }
}
.select-option-coin-item {
    display:flex; justify-content: flex-start; align-items: center;
    .item-icon {
        display:flex; justify-content: center; align-items: center; width:16px; height:16px;
        .img {width:100%; height:100%;}
    }
    .item-title {
        font-size:14px; font-weight:700; color:#333; margin:0 6px 0 8px;
    }
    .item-desc {
        font-size:12px; color:#999; font-weight:normal;
    }
    &.active {
        display:flex; justify-content: flex-start; align-items: center;
        .item-icon {
            display:flex; justify-content: center; align-items: center; width:16px; height:16px;
            .img {width:100%; height:100%;}
        }
        .item-title {
            font-size:14px; font-weight:700; color:#333; margin:0 6px 0 8px;
        }
        .item-desc {
            font-size:12px; color:#999; font-weight:normal;
        }
    }
}
.form-select-network {

}
::v-deep .el-select-group__title {
        width:400px; padding:10px; line-height:1.4; background:#f4f5f6; border-radius:4px; margin:5px 10px;
    }
.form-select-network-dropdown {


}
::v-deep .el-select-dropdown__item {
    height:auto;
    .select-option-network-item {
        padding:8px 0;
        .item-title {line-height:1.3;}
        .item-desc {
            display:flex; justify-content: space-between; align-items: center; font-weight:normal; font-size:12px; line-height:1.3;
            .item-text {

            }
        }
    }
}
.card {
            padding: 30px 0;
            .hd {
                .title {}
            }
            .bd {
                .table-wrapper {
                    padding:10px 0;
                    .table-tools {
                        .table-tabs {
                            display:flex; justify-content: flex-start; align-items: center;
                            .tab-item {
                                line-height:1; padding:8px 14px; border-radius:4px; background:#f4f5f6; margin:0 10px 10px 0; cursor: pointer;
                                &.active, &:hover {
                                    background:#e7eafe; color:#4458fe;
                                }
                            }
                        }
                    }
                    .table-inner{
                        .pagination {
                            padding:15px 0; text-align:right;
                        }
                    }
                }
            }
 }
</style>